import firebase from "firebase";

// let firebaseConfig = {
//   apiKey: "AIzaSyBVJIb6UcJoYektdU9FctkCN2DSWK4EVP8",
//   authDomain: "easy-36534.firebaseapp.com",
//   databaseURL: "https://easy-36534.firebaseio.com",
//   projectId: "easy-36534",
//   storageBucket: "easy-36534.appspot.com",
//   messagingSenderId: "719599948280",
//   appId: "1:719599948280:web:dce5a572f35621d737460d",
//   measurementId: "G-K6NRRLW2WC",
// };

// var firebaseConfig = {
//   //--------pido24 App config ids----------
//   apiKey: "AIzaSyCZp9Q7UWuDGo9Zb1QSi0g7lcwtxlxgMGE",
//   authDomain: "trof-3dad1.firebaseapp.com",
//   databaseURL: "https://trof-3dad1.firebaseio.com",
//   projectId: "trof-3dad1",
//   storageBucket: "trof-3dad1.appspot.com",
//   messagingSenderId: "429670046919",
//   appId: "1:429670046919:web:054d12963db5ab7259b2e2",
// };

// let fire = firebase.initializeApp(firebaseConfig);

// export default fire;

export async function connectFirebase() {
  // var firebaseConfig = {
  //   //--------pido24 App config ids----------
  //   apiKey: "AIzaSyCZp9Q7UWuDGo9Zb1QSi0g7lcwtxlxgMGE",
  //   authDomain: "trof-3dad1.firebaseapp.com",
  //   databaseURL: "https://trof-3dad1.firebaseio.com",
  //   projectId: "trof-3dad1",
  //   storageBucket: "trof-3dad1.appspot.com",
  //   messagingSenderId: "429670046919",
  //   appId: "1:429670046919:web:054d12963db5ab7259b2e2",
  // };

  // var firebaseConfig = {
  //   apiKey: "AIzaSyCN544TDH0yorLog8MeyX88S-ZWE_WlWPs",
  //   authDomain: "findlocal-67828.firebaseapp.com",
  //   projectId: "findlocal-67828",
  //   storageBucket: "findlocal-67828.appspot.com",
  //   messagingSenderId: "448032260439",
  //   appId: "1:448032260439:web:2963c9ae7c8871403a7e12",
  //   measurementId: "G-YHZW532X1W",
  // };

  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyD2GUiwFkhH9w6Mk6OBzwPC5LV9poCrHcs",
//   authDomain: "uplumber-e51a0.firebaseapp.com",
//   projectId: "uplumber-e51a0",
//   storageBucket: "uplumber-e51a0.appspot.com",
//   messagingSenderId: "989502393112",
//   appId: "1:989502393112:web:a1dde83c9523fabf17ec6d",
//   measurementId: "G-8TEG4BTJML"
// };
const firebaseConfig = {
  apiKey: "AIzaSyCBC9BjWHTZbGtxSxVGu_xMazi_F7hgKw0",
  authDomain: "u-plumber.firebaseapp.com",
  databaseURL: "https://u-plumber.firebaseio.com",
  projectId: "u-plumber",
  storageBucket: "u-plumber.appspot.com",
  messagingSenderId: "111016857916",
  appId: "1:111016857916:web:88068b3449ea7348f18e39",
  measurementId: "G-S6ENQ3ZSFM"
};
  // Initialize Firebase
  if (!firebase.apps.length) {
    console.log("FIREBASE CONNECTED!!!");
    return firebase.initializeApp(firebaseConfig);
  }
}
